import { Loader2 } from "lucide-react";

export function SpinnerIcon() {
	return <Loader2 className="h-6 w-6 animate-spin" />;
}
